module.exports = __webpack_public_path__ + "static/media/viber.53fe43d2.svg";